(()=>{
  const copyNode=document.querySelector('[data-rolled-canvas-copy]');
  if(!copyNode)return;
  const labels=JSON.parse(copyNode.textContent);
  const root=document.querySelector('[data-aap-root]');
  if(!root)return;
  let home,queued=false;
  const put=(node,key,value)=>{if(node&&node.style.getPropertyValue(key)!==value)node.style.setProperty(key,value);};
  const wording=(node,value)=>{if(node&&node.textContent!==value)node.textContent=value;};
  const colour=id=>/black/.test(id)?'Black':/white/.test(id)?'White':'None';
  function geometry(w,h,sw,sh,c){
    const border=c==='None'?0:Math.min(w,h)>100?50:20;
    const previewBorder=c==='None'?0:Math.min(w,h)*0.05;
    const scale=c==='None'?Math.max(w/sw,h/sh):Math.min((w-2*previewBorder)/sw,(h-2*previewBorder)/sh);
    return {border,left:(w-sw*scale)/2/w*100,top:(h-sh*scale)/2/h*100,width:sw*scale/w*100,height:sh*scale/h*100};
  }
  function appearance(node,g,c,w,h){
    if(!node)return;
    if(!node.classList.contains('arc-bordered-art'))node.classList.add('arc-bordered-art');
    if(node.dataset.arcColor!==c)node.dataset.arcColor=c;
    put(node,'--arc-ratio',w+' / '+h);
    put(node,'--arc-left',g.left+'%');put(node,'--arc-top',g.top+'%');
    put(node,'--arc-width',g.width+'%');put(node,'--arc-height',g.height+'%');
    put(node,'--arc-clip-x',Math.max(0,(g.width-100)/2/g.width*100)+'%');
    put(node,'--arc-clip-y',Math.max(0,(g.height-100)/2/g.height*100)+'%');
    put(node,'--arc-colour',c==='White'?'#fff':'#151515');
  }
  function sync(){
    queued=false;
    if(!root.closest('.dwell-art-product')?.dataset.acvReady)return;
    const finish=root.querySelector('[data-aap-step="finish"]');
    const sizes=root.querySelector('[data-aap-step="size"]');
    if(!finish||!sizes)return;
    const active=document.body.dataset.artworkBrowse==='canvas'&&document.body.dataset.artworkFinish==='rolled';
    const link=root.querySelector('[aria-controls="AlphaProductEdgeDialog"]');
    if(active){
      root.querySelectorAll('[data-aap-sizes] button[data-value^="rolled-canvas::"]>span').forEach(price=>{
        if(!price.classList.contains('translation-shop-selector'))price.classList.add('translation-shop-selector');
        let numeric=price.textContent.replace(/[٠-٩]/g,d=>String(d.charCodeAt(0)-1632)).replace(/[۰-۹]/g,d=>String(d.charCodeAt(0)-1776)).replace(/٫/g,'.').replace(/٬/g,',').replace(/[^0-9.,]/g,'');
        const end=Math.max(numeric.lastIndexOf('.'),numeric.lastIndexOf(','));
        numeric=end>=0&&numeric.length-end-1<=2?numeric.slice(0,end).replace(/[.,]/g,'')+'.'+numeric.slice(end+1):numeric.replace(/[.,]/g,'');
        const amount=Number(numeric),currency=document.querySelector('[data-translation-shop-currency]')?.value||root.dataset.aapCurrency||'EUR';
        if(Number.isFinite(amount)&&amount>0)wording(price,new Intl.NumberFormat(document.documentElement.lang||root.dataset.aapLocale||'en',{style:'currency',currency}).format(amount));
      });
      if(!home){home=document.createComment('rolled-finish-home');finish.before(home);}
      if(sizes.nextElementSibling!==finish)sizes.after(finish);
      if(!finish.classList.contains('arc-inline-finishes'))finish.classList.add('arc-inline-finishes');if(finish.hidden)finish.hidden=false;
      if(link&&!link.classList.contains('arc-hidden-link'))link.classList.add('arc-hidden-link');
      wording(finish.querySelector('legend'),labels.title);
      const selected=root.querySelector('[data-aap-sizes] [aria-pressed="true"]')||sizes.querySelector('[data-value][aria-pressed="true"]');
      const parts=selected?.dataset.value?.split('::');
      if(!parts||parts[0]!=='rolled-canvas')return;
      const w=Number(parts[1]),h=Number(parts[2]);
      const sw=Number(root.dataset.aapSourceWidth),sh=Number(root.dataset.aapSourceHeight);
      if(![w,h,sw,sh].every(n=>n>0))return;
      const hero=root.querySelector('[data-aap-product-preview] img');
      const imageSrc=hero?.currentSrc||hero?.src||labels.image;
      finish.querySelectorAll('button[data-value]').forEach(button=>{
        const c=colour(button.dataset.value),g=geometry(w,h,sw,sh,c);
        let preview=button.querySelector('.arc-edge-preview');
        if(!preview){preview=document.createElement('span');preview.className='arc-edge-preview';const img=document.createElement('img');img.alt='';img.loading='eager';preview.append(img);button.prepend(preview);}
        const img=preview.querySelector('img');if(img.getAttribute('src')!==imageSrc)img.src=imageSrc;
        appearance(preview,g,c,w,h);
        wording(button.querySelector('strong'),labels[c.toLowerCase()]);
        let detail=button.querySelector('.arc-border-width');if(!detail){detail=document.createElement('span');detail.className='arc-border-width';button.append(detail);}
        wording(detail,c==='None'?labels.full_bleed:labels.margin.replace('[cm]',g.border/10));
      });
      let note=finish.querySelector('.arc-margin-note');if(!note){note=document.createElement('p');note.className='arc-margin-note';finish.append(note);}
      wording(note,labels.dimensions);
      const choice=finish.querySelector('button[data-value][aria-pressed="true"]');
      const c=colour(choice?.dataset.value||'rolled-edge-black'),g=geometry(w,h,sw,sh,c);
      root.querySelectorAll('.asc-canvas.asc-rolled').forEach(node=>appearance(node,g,c,w,h));
      const room=root.querySelector('[data-aap-preview].is-rolled .aap-art__gap');appearance(room,g,c,w,h);
    }else{
      if(home&&finish.previousSibling!==home)home.after(finish);
      if(finish.classList.contains('arc-inline-finishes'))finish.classList.remove('arc-inline-finishes');if(link?.classList.contains('arc-hidden-link'))link.classList.remove('arc-hidden-link');
      root.querySelectorAll('.arc-bordered-art').forEach(node=>{node.classList.remove('arc-bordered-art');delete node.dataset.arcColor;});
    }
  }
  const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(sync);}};
  new MutationObserver(schedule).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-pressed','data-aap-active-support','data-acv-ready','class','style','hidden','src']});
  new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['data-artwork-browse','data-artwork-finish']});
  new MutationObserver(schedule).observe(root.closest('.dwell-art-product'),{attributes:true,attributeFilter:['data-acv-ready']});
  schedule();
})();
